import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { EmployeeDocumentCategoryDto } from "@/core/features/employee-document-categories/employee-document-category.dto";
import { EmployeeDocumentCategoryTemplateVersionDto } from "@/core/features/employee-document-categories/employee-document-category-template-version.dto";
import { EmployeeDocumentVersionDto } from "@/core/features/employee-documents/employee-document-version.dto";
import { SignaturePlacementDto } from "@/core/features/employee-document-categories/signature-placement.dto";
import { Transform, Type } from "class-transformer";
import { parseApiDate } from "@/utils/dates/dateFormats";

export class EmployeeOnboardingSignatureRequirementDto extends BaseEntityDto {
  processId: string;
  categoryId: string;
  categoryTemplateVersionId: string;
  overrideStorageKey?: string | null;
  overrideFilename?: string | null;
  isRequired: boolean;
  isSelected: boolean;
  sortOrder: number;
  acceptanceEvidenceId?: string | null;
  isCurrentAcceptanceValid: boolean;
  reviewMessage?: string | null;

  @Transform(({ value }) => parseApiDate(value))
  acceptedAt?: Date | null;

  @Type(() => EmployeeDocumentCategoryDto)
  category: EmployeeDocumentCategoryDto;

  @Type(() => EmployeeDocumentCategoryTemplateVersionDto)
  categoryTemplateVersion: EmployeeDocumentCategoryTemplateVersionDto;

  @Type(() => EmployeeDocumentVersionDto)
  acceptanceEvidence?: EmployeeDocumentVersionDto | null;

  @Type(() => SignaturePlacementDto)
  placements?: SignaturePlacementDto[];
}
